import React from "react";
// 데이터 문서 import 데이터명 from "경로";
// import dealdata from "./dealdata";
// import "../assets/css/minireset.css";
import Deallist from "./Deallist";
import styles from "./Deal.module.css";
import dealdata from './dealdata'

const Deal1 = () => {
    return (
        <div className={styles.deal}>
         <div className={styles.title}>퍼펙트 딜!</div>
          <div className={styles.subtitle}>완벽한 하루에서 합리적인 가격으로 구매해보세요.</div>
          <Deallist dealdata={dealdata} />
          <div className={styles.view}><a href="#">더보기</a></div>
        </div>
    );
};

export default Deal1;